import { useRoutes } from "react-router-dom";
import "./App.css";
import { getAppRoutes } from "./router/router";
import { CssBaseline, ThemeProvider } from "@mui/material";
import 'reactflow/dist/style.css';
import { LoadingAndErrors } from "./views/Loading&Errors/LoadingAndErrors";
import { UberEatsProvider } from "./providers/UberEatsProvider/UberEatsProvider";
import { useAuthProvider } from "./providers";
import { IStoreState, useAppSelector } from "./redux";
import { ThemeSettings } from "./layout/FullLayout/customizer/ThemeSettings";

function App() {
  const { authInfo: { user: { role_value } } } = useAuthProvider();
  const routing = useRoutes(getAppRoutes(role_value === "USER"));
  const theme = ThemeSettings();
  const customizer = useAppSelector(
    (state: IStoreState) => state.customizer,
  );

  return (
    <>
    <ThemeProvider theme={theme}>
      <UberEatsProvider>
        <CssBaseline />
        {routing}
      </UberEatsProvider>
      <LoadingAndErrors />
      </ThemeProvider>
    </>
  );
}

export default App;